var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
const DEFAULT_CONFIG = {
    steem_api: 'https://api.steemit.com',
    hive_api: 'https://api.openhive.network',
    blurt_api: 'https://rpc.blurt.blog'
};
let configPromise = null;
const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = yield response.json();
                if (json.ok && json.data)
                    return json.data;
            }
            catch (error) {
                console.warn('⚠️ Server unreachable, using defaults:', error);
            }
            return DEFAULT_CONFIG;
        }))();
    }
    const config = yield configPromise;
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
export const WalletHistoryItemComponent = ({ transaction, onExportTxt, }) => {
    var _a;
    const [showDetails, setShowDetails] = React.useState(false);
    // Modal per Trx ID
    const [showTxModal, setShowTxModal] = React.useState(false);
    const [txDetails, setTxDetails] = React.useState(null);
    const [txLoading, setTxLoading] = React.useState(false);
    const [txError, setTxError] = React.useState(null);
    // Modal per Block/Tx Num
    const [showBlockModal, setShowBlockModal] = React.useState(false);
    const [blockTxDetails, setBlockTxDetails] = React.useState(null);
    const [blockLoading, setBlockLoading] = React.useState(false);
    const [blockError, setBlockError] = React.useState(null);
    const formatTimestamp = (ts) => {
        const date = new Date(ts);
        return date.toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    // =====================================
    // RILEVAMENTO OPERAZIONI VIRTUALI
    // =====================================
    const isVirtualOperation = () => {
        // 1. TXID nullo o zero (incluso "0000...00")
        const isZeroTx = transaction.txId === '0' ||
            transaction.txId === '-' ||
            transaction.txId === '0000000000000000000000000000000000000000';
        // 2. trx_in_block = 4294967295 (MAX_UINT32, segno di operazione virtuale)
        const isMaxTrxInBlock = transaction.trx_in_block === 4294967295;
        // 3. virtual_op presente e diverso da 0/falso
        const hasVirtualOp = !!transaction.virtual_op &&
            (typeof transaction.virtual_op === 'number' ? transaction.virtual_op > 0 : true);
        // 4. TXID contiene "virtual" (alcune chain lo mettono esplicitamente)
        const containsVirtual = typeof transaction.txId === 'string' &&
            transaction.txId.toLowerCase().includes('virtual');
        return isZeroTx || isMaxTrxInBlock || hasVirtualOp || containsVirtual;
    };
    // RPC endpoint: STEEM e TIME forzano api.steemit.com
    const getRpcUrlForChain = () => __awaiter(void 0, void 0, void 0, function* () {
        const chain = (transaction.currency || 'STEEM').toLowerCase();
        if (chain === 'steem' || chain === 'time') {
            return 'https://api.steemit.com';
        }
        return yield getDefVal(`${chain}_api`);
    });
    // ===================== FETCH TX DETAILS =====================
    const fetchTxDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isVirtualOperation() || !transaction.txId) {
            setTxError('Virtual operation, no transaction details available');
            return;
        }
        setTxLoading(true);
        setTxDetails(null);
        setTxError(null);
        try {
            const rpcUrl = yield getRpcUrlForChain();
            const payload = {
                jsonrpc: '2.0',
                method: 'condenser_api.get_transaction',
                params: [transaction.txId],
                id: 1
            };
            const response = yield fetch(rpcUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = yield response.json();
            if (data.error) {
                throw new Error(data.error.message || 'RPC Error');
            }
            if (data.result) {
                setTxDetails(data.result);
            }
            else {
                setTxError('Transaction not found on this chain');
            }
        }
        catch (error) {
            console.error('Error fetching transaction details:', error);
            setTxError(error instanceof Error ? error.message : 'Failed to fetch transaction from RPC');
        }
        finally {
            setTxLoading(false);
        }
    });
    // ===================== FETCH BLOCK, FILTER TRANSACTION =====================
    const fetchBlockTxDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        if (!transaction.blockNumber) {
            setBlockError('No block number available');
            return;
        }
        // Se è un'operazione virtuale, non c'è transazione reale nel blocco
        if (isVirtualOperation()) {
            setBlockError('Virtual operations are not stored in blocks. They are generated during blockchain processing.');
            return;
        }
        setBlockLoading(true);
        setBlockTxDetails(null);
        setBlockError(null);
        try {
            const rpcUrl = yield getRpcUrlForChain();
            const payload = {
                jsonrpc: '2.0',
                method: 'condenser_api.get_block',
                params: [transaction.blockNumber],
                id: 1
            };
            const response = yield fetch(rpcUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = yield response.json();
            if (data.error) {
                throw new Error(data.error.message || 'RPC Error');
            }
            if (data.result && data.result.transactions) {
                const targetTxNum = (_b = transaction.trx_in_block) !== null && _b !== void 0 ? _b : 0;
                // CERCHIAMO LA TRANSAZIONE CON transaction_num === trx_in_block
                const matchedTx = data.result.transactions.find((tx) => tx.transaction_num === targetTxNum);
                if (matchedTx) {
                    setBlockTxDetails(matchedTx);
                }
                else {
                    setBlockError(`Transaction #${targetTxNum} not found in block #${transaction.blockNumber}`);
                }
            }
            else {
                setBlockError('Block or transactions not found on this chain');
            }
        }
        catch (error) {
            console.error('Error fetching block transaction details:', error);
            setBlockError(error instanceof Error ? error.message : 'Failed to fetch from RPC');
        }
        finally {
            setBlockLoading(false);
        }
    });
    const openTxModal = () => {
        setShowTxModal(true);
        fetchTxDetails();
    };
    const openBlockModal = () => {
        setShowBlockModal(true);
        fetchBlockTxDetails();
    };
    // ===================== FORMAT VALUE =====================
    const formatValue = (value) => {
        if (value === null || value === undefined) {
            return React.createElement("span", { style: { color: '#999', fontStyle: 'italic' } }, "null");
        }
        if (typeof value === 'boolean') {
            return React.createElement("span", { style: { color: '#666' } }, String(value));
        }
        if (typeof value === 'number') {
            return React.createElement("span", { style: { color: '#2e7d32', fontWeight: '500' } }, value);
        }
        if (Array.isArray(value)) {
            return (React.createElement("div", { style: { margin: '4px 0', paddingLeft: '8px', borderLeft: '2px solid #ddd' } }, value.map((item, idx) => (React.createElement("div", { key: idx, style: { marginBottom: '4px' } }, typeof item === 'object' && item !== null ? (React.createElement("pre", { style: {
                    margin: '0',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '10.5px',
                    color: '#555',
                    background: '#fafafa',
                    padding: '4px',
                    borderRadius: '2px'
                } }, JSON.stringify(item, null, 2))) : (React.createElement("span", { style: { fontFamily: 'monospace', fontSize: '11px' } }, String(item))))))));
        }
        if (typeof value === 'object') {
            return (React.createElement("pre", { style: {
                    margin: '2px 0 2px 8px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '10.5px',
                    color: '#444',
                    background: '#f5f5f5',
                    padding: '4px',
                    borderRadius: '2px',
                    borderLeft: '2px solid #ddd'
                } }, JSON.stringify(value, null, 2)));
        }
        return React.createElement("span", { style: { color: '#333' } }, String(value));
    };
    // ===================== RENDER TRANSACTION CONTENT =====================
    const renderTransactionDetails = (txn) => {
        if (!txn)
            return null;
        return (React.createElement("div", { style: { fontSize: '11.5px' } },
            React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Transaction ID:"),
                React.createElement("span", { style: { fontFamily: 'monospace', fontSize: '11px', marginLeft: '4px', color: '#1976d2' } }, txn.transaction_id || txn.id)),
            React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Block Num:"),
                " ",
                txn.block_num),
            txn.transaction_num != null && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Transaction Num:"),
                " ",
                txn.transaction_num)),
            txn.expiration && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Expiration:"),
                ' ',
                React.createElement("span", { style: { fontFamily: 'monospace' } }, txn.expiration))),
            txn.ref_block_num != null && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Ref Block Num:"),
                " ",
                txn.ref_block_num)),
            txn.ref_block_prefix != null && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Ref Block Prefix:"),
                " ",
                txn.ref_block_prefix)),
            txn.extensions && txn.extensions.length > 0 && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null, "Extensions:"),
                formatValue(txn.extensions))),
            txn.signatures && txn.signatures.length > 0 && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null,
                    "Signatures (",
                    txn.signatures.length,
                    "):"),
                txn.signatures.map((sig, idx) => (React.createElement("div", { key: idx, style: {
                        fontFamily: 'monospace',
                        fontSize: '10px',
                        wordBreak: 'break-all',
                        marginTop: '2px',
                        color: '#666'
                    } },
                    sig.substring(0, 50),
                    "..."))))),
            txn.operations && txn.operations.length > 0 && (React.createElement("div", { style: { marginBottom: '6px' } },
                React.createElement("strong", null,
                    "Operations (",
                    txn.operations.length,
                    "):"),
                txn.operations.map((op, idx) => (React.createElement("div", { key: idx, style: {
                        marginTop: '4px',
                        padding: '4px',
                        background: '#f9f9f9',
                        borderRadius: '2px',
                        marginBottom: '2px'
                    } },
                    React.createElement("div", { style: { fontWeight: '500', color: '#333' } },
                        "Op #",
                        idx,
                        ": ",
                        op[0]),
                    formatValue(op[1]))))))));
    };
    // ===================== RENDER ITEM DETAILS =====================
    const renderDetails = () => {
        const { details } = transaction;
        if (!details || Object.keys(details).length === 0)
            return null;
        return (React.createElement("div", null, Object.entries(details).map(([key, value]) => (React.createElement("div", { key: key, style: { marginBottom: '5px' } },
            React.createElement("strong", { style: { color: '#555' } },
                key,
                ": "),
            React.createElement("span", { style: { display: 'inline-block' } }, formatValue(value)))))));
    };
    // ===================== MODAL STYLES =====================
    const modalOverlayStyle = {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px'
    };
    const modalContentStyle = {
        background: '#fff',
        borderRadius: '8px',
        width: '95%',
        maxWidth: '600px',
        maxHeight: '80vh',
        overflow: 'auto',
        padding: '12px',
        position: 'relative'
    };
    const modalHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
        paddingBottom: '8px',
        borderBottom: '1px solid #eee'
    };
    const modalCloseBtnStyle = {
        background: '#f0f0f0',
        border: 'none',
        borderRadius: '4px',
        padding: '4px 10px',
        cursor: 'pointer',
        fontSize: '14px'
    };
    const modalLoadingStyle = {
        padding: '20px',
        textAlign: 'center',
        color: '#666',
        fontSize: '13px'
    };
    const modalErrorStyle = {
        padding: '12px',
        background: '#ffebee',
        borderRadius: '4px',
        color: '#c62828',
        fontSize: '12.5px'
    };
    // ===================== MAIN RENDER =====================
    const virtualOpIndex = (_a = transaction.virtual_op) !== null && _a !== void 0 ? _a : transaction.index;
    return (React.createElement("div", { onClick: () => setShowDetails(!showDetails), style: {
            cursor: 'pointer',
            padding: '8px',
            boxSizing: 'border-box',
            width: '100%',
            backgroundColor: showDetails ? '#f8f9fa' : '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
            marginBottom: '4px',
            minWidth: 0,
        } },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                fontSize: '13.5px',
                lineHeight: '1.35',
            } },
            React.createElement("div", { style: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                } },
                React.createElement("span", null,
                    React.createElement("span", { style: { color: '#666' } }, "Op.: "),
                    React.createElement("strong", null, transaction.index)),
                onExportTxt && (React.createElement("button", { type: "button", title: "Save this operation as .txt", onClick: (e) => {
                        e.stopPropagation();
                        onExportTxt();
                    }, style: {
                        padding: '1px 6px',
                        fontSize: '11px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        background: '#f5f5f5',
                        cursor: 'pointer',
                        lineHeight: 1.2,
                    } }, "TXT"))),
            React.createElement("div", { style: { marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 } },
                React.createElement("span", { style: { color: '#555', whiteSpace: 'nowrap' } },
                    React.createElement("span", { style: { color: '#666' } }, "Date: "),
                    formatTimestamp(transaction.timestamp)),
                React.createElement("span", { style: { fontSize: '13px', color: '#999', cursor: 'pointer', flexShrink: 0 } }, showDetails ? '▼' : '▶'))),
        React.createElement("div", { style: { fontSize: '13.5px', marginTop: '3px', color: '#222' } },
            React.createElement("span", { style: { color: '#666' } }, "Type: "),
            React.createElement("strong", null, transaction.type)),
        React.createElement("div", { style: { fontSize: '12.5px', color: '#555', marginTop: '3px', wordBreak: 'break-all' } },
            React.createElement("span", { style: { color: '#666' } }, "Trx Id: "),
            isVirtualOperation() ? (React.createElement("span", { style: { fontStyle: 'italic', color: '#777' } },
                "Virtual Op #",
                virtualOpIndex)) : (React.createElement("span", { onClick: (e) => {
                    e.stopPropagation();
                    openTxModal();
                }, style: {
                    color: '#1976d2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontFamily: 'monospace',
                    fontSize: '0.9em'
                } }, transaction.txId))),
        transaction.blockNumber != null && (React.createElement("div", { style: { fontSize: '12.5px', color: '#555', marginTop: '2px' } },
            React.createElement("span", { style: { color: '#666' } }, isVirtualOperation() ? 'Block/Virtual Op: ' : 'Block/Tx Num: '),
            isVirtualOperation() ? (React.createElement("span", { style: { fontFamily: 'monospace', fontSize: '0.9em', color: '#777' } },
                transaction.blockNumber,
                "/",
                virtualOpIndex)) : transaction.trx_in_block != null ? (React.createElement("span", { onClick: (e) => {
                    e.stopPropagation();
                    openBlockModal();
                }, style: {
                    color: '#1976d2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontFamily: 'monospace',
                    fontSize: '0.9em'
                } },
                transaction.blockNumber,
                "/",
                transaction.trx_in_block)) : null)),
        showDetails && (React.createElement("div", { style: { marginTop: '8px', padding: '8px', background: '#fff', border: '1px solid #eee', borderRadius: '3px', fontSize: '11.5px' } },
            React.createElement("div", { style: { marginBottom: '5px' } },
                React.createElement("strong", null, "Block:"),
                " ",
                transaction.blockNumber),
            React.createElement("div", { style: { marginBottom: '5px' } },
                React.createElement("strong", null, "Num Trx:"),
                " ",
                transaction.trx_in_block),
            React.createElement("div", { style: { marginBottom: '5px' } },
                React.createElement("strong", null, "Op Trx:"),
                " ",
                transaction.op_in_trx),
            renderDetails())),
        showTxModal && (React.createElement("div", { style: modalOverlayStyle, onClick: () => setShowTxModal(false) },
            React.createElement("div", { style: modalContentStyle, onClick: (e) => e.stopPropagation() },
                React.createElement("div", { style: modalHeaderStyle },
                    React.createElement("h3", { style: { margin: 0, fontSize: '16px' } },
                        "Transaction Details",
                        React.createElement("span", { style: { fontSize: '12px', color: '#666', marginLeft: '8px' } },
                            "(",
                            transaction.currency,
                            ")")),
                    React.createElement("button", { style: modalCloseBtnStyle, onClick: () => setShowTxModal(false) }, "\u2715")),
                txLoading && React.createElement("div", { style: modalLoadingStyle }, "Fetching from RPC..."),
                txError && React.createElement("div", { style: modalErrorStyle },
                    React.createElement("strong", null, "Error:"),
                    " ",
                    txError),
                !txLoading && !txError && txDetails && renderTransactionDetails(txDetails),
                !txLoading && !txError && !txDetails && (React.createElement("div", { style: modalLoadingStyle }, "No transaction details available"))))),
        showBlockModal && (React.createElement("div", { style: modalOverlayStyle, onClick: () => setShowBlockModal(false) },
            React.createElement("div", { style: modalContentStyle, onClick: (e) => e.stopPropagation() },
                React.createElement("div", { style: modalHeaderStyle },
                    React.createElement("h3", { style: { margin: 0, fontSize: '16px' } },
                        "Transaction from Block #",
                        transaction.blockNumber,
                        React.createElement("span", { style: { fontSize: '12px', color: '#666', marginLeft: '8px' } },
                            "(",
                            transaction.currency,
                            ")")),
                    React.createElement("button", { style: modalCloseBtnStyle, onClick: () => setShowBlockModal(false) }, "\u2715")),
                blockLoading && React.createElement("div", { style: modalLoadingStyle }, "Fetching from RPC..."),
                blockError && React.createElement("div", { style: modalErrorStyle },
                    React.createElement("strong", null, "Error:"),
                    " ",
                    blockError),
                !blockLoading && !blockError && blockTxDetails && renderTransactionDetails(blockTxDetails),
                !blockLoading && !blockError && !blockTxDetails && (React.createElement("div", { style: modalLoadingStyle }, "No transaction found")))))));
};
